import * as DTOS from "../FeralScan.dtos";


export interface ILoginActions {
    type: string;
}

export interface ILoginAction extends ILoginActions {
    username: string;
    password: string;
    rememberMe: boolean;
}

export interface ILoginWithTokenAction extends ILoginActions {
    username: string;
    password: string;
}

export interface ILoginSuccessAction extends ILoginActions {
    user: DTOS.AuthenticateResponse;
}

export interface ILogoutSuccessAction extends ILoginActions {
    user: DTOS.AuthenticateResponse;
}


export interface ILoginFailAction extends ILoginActions {
    responseStatus: DTOS.ResponseStatus;
}

export interface ILogoutAction extends ILoginActions {
}

export const
    LOGIN = "LOGIN",
    LOGIN_WITH_TOKEN = "LOGIN_WITH_TOKEN",
    LOGIN_SUCCESS = "LOGIN_SUCCESS",
    LOGIN_FAIL = "LOGIN_FAIL",

    LOGOUT = "LOGOUT",
    LOGOUT_SUCCESS = "LOGOUT_SUCCESS";


export function logout(): ILogoutAction {
    return {
        type: LOGOUT
    };
}

export function login(username: string, password: string, rememberMe: boolean): ILoginAction {
    return {
        type: LOGIN,
        username,
        password,
        rememberMe
    };
}

export function loginWithToken(username: string, password: string): ILoginWithTokenAction {
    return {
        type: LOGIN_WITH_TOKEN,
        username,
        password
    };
}

export function logoutSuccess(response: DTOS.AuthenticateResponse): ILogoutSuccessAction {
    return {
        type: LOGOUT_SUCCESS,
        user: response
    };
}

export function loginSuccess(response: DTOS.AuthenticateResponse): ILoginSuccessAction {
    return {
        type: LOGIN_SUCCESS,
        user: response
    };
}
export function loginFail(response): ILoginFailAction {
    return {
        type: LOGIN_FAIL,
        responseStatus: response.responseStatus
    };
}